/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.IntegrationDataMappingRule = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The IntegrationDataMappingRule model module.
   * @module model/IntegrationDataMappingRule
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>IntegrationDataMappingRule</code>.
   * @alias module:model/IntegrationDataMappingRule
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>IntegrationDataMappingRule</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationDataMappingRule} obj Optional instance to populate.
   * @return {module:model/IntegrationDataMappingRule} The populated <code>IntegrationDataMappingRule</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('DataMappingDimensionID')) {
        obj['DataMappingDimensionID'] = ApiClient.convertToType(data['DataMappingDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('SourceID')) {
        obj['SourceID'] = ApiClient.convertToType(data['SourceID'], 'Integer');
      }
      if (data.hasOwnProperty('MatchRuleID')) {
        obj['MatchRuleID'] = ApiClient.convertToType(data['MatchRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('MatchRuleData')) {
        obj['MatchRuleData'] = ApiClient.convertToType(data['MatchRuleData'], 'String');
      }
      if (data.hasOwnProperty('TargetRuleData')) {
        obj['TargetRuleData'] = ApiClient.convertToType(data['TargetRuleData'], 'String');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('DataMappingTypeID')) {
        obj['DataMappingTypeID'] = ApiClient.convertToType(data['DataMappingTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('SourceLegalEntityID')) {
        obj['SourceLegalEntityID'] = ApiClient.convertToType(data['SourceLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} DataMappingDimensionID
   * @default 0
   */
  exports.prototype['DataMappingDimensionID'] = 0;
  /**
   * @member {Integer} SourceID
   * @default 0
   */
  exports.prototype['SourceID'] = 0;
  /**
   * @member {Integer} MatchRuleID
   * @default 0
   */
  exports.prototype['MatchRuleID'] = 0;
  /**
   * @member {String} MatchRuleData
   * @default ''
   */
  exports.prototype['MatchRuleData'] = '';
  /**
   * @member {String} TargetRuleData
   * @default ''
   */
  exports.prototype['TargetRuleData'] = '';
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} DataMappingTypeID
   * @default 0
   */
  exports.prototype['DataMappingTypeID'] = 0;
  /**
   * @member {Integer} SourceLegalEntityID
   */
  exports.prototype['SourceLegalEntityID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


